import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-36 pb-24 font-sans">
      <h1 className="text-[32px] font-bold text-secondary mb-6">Privacy Policy</h1>
      
      <div className="space-y-6 text-[#555] text-[15px] leading-relaxed">
        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">1. Information We Collect</h2>
          <p className="mb-2">We may collect the following information:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Name</li>
            <li>Company details</li>
            <li>Contact number</li>
            <li>Email address</li>
            <li>Business category</li>
            <li>Website or social media links</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">2. How We Use Information</h2>
          <p className="mb-2">Collected information may be used to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Create vendor profiles</li>
            <li>Connect vendors with architects and designers</li>
            <li>Improve platform services</li>
            <li>Send updates, announcements, and promotional messages</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">3. Data Protection</h2>
          <p>
            Top Interiors India takes reasonable measures to protect user data from unauthorized access, misuse, or disclosure. However, users share information on the platform at their own discretion.
          </p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">4. Third-Party Sharing</h2>
          <p className="mb-2">We do not sell personal data to third parties.</p>
          <p className="mb-2">Information may be shared only when necessary for:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Platform operations</li>
            <li>Legal compliance</li>
            <li>Service improvement</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">5. Cookies</h2>
          <p className="mb-2">The website may use cookies to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Enhance user experience</li>
            <li>Analyze traffic</li>
            <li>Improve website functionality</li>
          </ul>
          <p className="mt-2">Users can manage cookie preferences through their browser settings.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">6. User Rights</h2>
          <p className="mb-2">Users may request to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Update their information</li>
            <li>Correct inaccurate details</li>
            <li>Remove their listing or account</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">7. Policy Updates</h2>
          <p>
            Top Interiors India may update this Privacy Policy from time to time to reflect platform improvements and regulatory requirements.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
